import {forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState} from 'react'
import Camera, {FACING_MODES} from 'react-html5-camera-photo';
import "react-html5-camera-photo/build/css/index.css";
import ImagePreview from "./ImagePreview";

// import DebugContext from "../../contexts/debugContext.js";

// TODO Cancel ?
function VinPicture({
                        stepValueChanged
                    }, ref) {
    const [dataUri, setDataUri] = useState('');
    // const debug = useContext(DebugContext);

    useEffect(() => {
        if (dataUri != '') {
            stepValueChanged(true);
        } else {
            stepValueChanged(false);
        }
    }, [dataUri]);

    useImperativeHandle(ref, () => ({
        getValue() {
            return dataUri;
        }
    }));

    function handleTakePhoto(dataUri) {
        // console.log(dataUri);
        setDataUri(dataUri);
    }

    return (
        <div>
            <label>VIN SCANNER</label>
            <div
                style={{
                    border: 'solid 1px black',
                    backgroundColor: 'white'
                }}
            >
                {dataUri ?
                    <ImagePreview dataUri={dataUri}/>
                    :
                    <Camera
                        idealFacingMode={FACING_MODES.ENVIRONMENT}
                        onTakePhoto={(dataUri) => {
                            handleTakePhoto(dataUri);
                        }}
                    />
                }
            </div>
        </div>
    )
}

export default forwardRef(VinPicture);